<input
  #fileInput
  type="file"
  multiple
  class="visually-hidden"
  [accept]="accept"
  [attr.aria-label]="chooseLabel"
  [disabled]="disabled"
  (change)="onFileInputChange($event)">

<button
  type="button"
  class="drop-zone"
  [disabled]="disabled"
  (click)="fileInput.click()"
  (dragover)="onDragOver($event)"
  (drop)="onDrop($event)">
  <ion-icon name="cloud-upload-outline" aria-hidden="true"></ion-icon>
  <strong>{{ dropHint || chooseLabel }}</strong>
  <span *ngIf="helperText">{{ helperText }}</span>
</button>

<div class="file-list" *ngIf="items.length > 0">
  <article class="file-row" *ngFor="let item of items; trackBy: trackByItem">
    <ion-icon name="document-attach-outline" aria-hidden="true"></ion-icon>
    <div class="file-copy">
      <strong>{{ item.file.name }}</strong>
      <span *ngIf="formatFileSize(item.file.size) as displaySize">
        {{ displaySize.translationKey | translate:{ size: (displaySize.size | number:'1.0-2') } }}
      </span>
      <small *ngIf="item.error">{{ item.error | translate }}</small>
      <ion-progress-bar *ngIf="item.progress > 0 && !item.error" [value]="item.progress / 100"></ion-progress-bar>
    </div>
    <app-icon-button
      icon="close-outline"
      color="danger"
      size="sm"
      [disabled]="disabled"
      [ariaLabel]="removeLabelKey | translate:{ file: item.file.name }"
      (clicked)="removeFile(item.id)">
    </app-icon-button>
  </article>
</div>